<template>
  <div class="vid-res-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.title"
        placeholder="请输入标题"
        size="small"
        class="param-input"
        clearable
      ></el-input>
      <el-input
        v-model="params.tag"
        placeholder="请输入标签"
        size="small"
        class="param-input"
        clearable
      ></el-input>
      <el-input
        v-model="params.vlogger_id"
        placeholder="请输入UP主ID"
        size="small"
        class="param-input"
        clearable
      ></el-input>
      <el-input
        v-model="params.media_center_id"
        placeholder="请输入媒资中心ID"
        size="small"
        class="param-input"
        clearable
      ></el-input>
      <el-select
        v-model="params.is_up"
        size="small"
        clearable
        placeholder="请选择是否up主"
        @change="getList('status')"
      >
        <el-option
          v-for="(item, i) in is_ups"
          :value="item.value"
          :label="item.label"
          :key="i"
        ></el-option>
      </el-select>
      <el-select
        v-model="params.media_type"
        size="small"
        placeholder="请选择媒体类型"
        clearable
        @change="getList('status')"
      >
        <el-option
          v-for="(item, i) in media_types"
          :value="item.value"
          :label="item.label"
          :key="i"
        ></el-option>
      </el-select>
      <el-select
        v-model="params.sync_type"
        size="small"
        clearable
        placeholder="请选择同步类型"
        @change="getList('status')"
      >
        <el-option
          v-for="(item, i) in sync_types"
          :value="item.value"
          :label="item.label"
          :key="i"
        ></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="getList()">搜索</el-button>
      <el-button
        type="primary"
        size="small"
        @click="openSelection"
        :disabled="isDisabled"
        >批量操作</el-button
      >
      <el-button
        type="success"
        size="small"
        @click="synchronizeMedia"
        :disabled="isDisabled"
        >同步</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%;"
      max-height="800px"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      @sort-change="handleSortChange"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        v-if="isSelection"
        width="55"
        fixed="left"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        align="center"
        min-width="240"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.title || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="anchor"
        label="作者"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="total_episode"
        label="总集数"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.total_episode || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="media_type"
        label="媒体类型"
        align="center"
        min-width="100">
        <template slot-scope="scope">
          <el-tag type="success">{{getMediaTypeName(scope.row.media_type)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="sale_coin"
        label="整部售价"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sale_coin || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="子媒体" align="center" width="80">
        <template slot-scope="scope">
          <i
            class="el-icon-video-play views"
            title="点击查看"
            @click="openSubMedia(scope.row)"
          ></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="update_status"
        label="更新状态"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.update_status == 1"
            >连载中</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.update_status == 2"
            >完结</el-tag
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="横版封面" align="center" width="100" prop="cover">
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'60px'"
            :src="
              checkUrl(scope.row.horizontal_cover) + scope.row.horizontal_cover
            "
          >
          </img-load>
        </template>
      </el-table-column>
      <el-table-column label="竖版封面" align="center" width="100" prop="cover">
        <template slot-scope="scope">
          <img-load
            :width="'60px'"
            :height="'80px'"
            :src="checkUrl(scope.row.vertical_cover) + scope.row.vertical_cover"
          >
          </img-load>
        </template>
      </el-table-column>
      <el-table-column prop="tags_text" label="标签" align="center" width="320">
        <template slot-scope="scope">
          <span>{{ scope.row.tags_text || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="summary" label="简介" align="center" width="320">
        <template slot-scope="scope">
          <span>{{ scope.row.summary || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="update_time"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.update_time * 1000) | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.create_time * 1000) | changeDate }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <div class="bottom">
      <div class="btn" v-if="isSelection">
        <el-button type="info" size="mini" @click="giveUp">放弃操作</el-button>
        <el-button type="success" size="mini" @click="useVideo">使用</el-button>
        <el-button type="primary" size="mini" @click="neglectVideo"
          >忽略</el-button
        >
      </div>
      <div v-else></div>
      <el-pagination
        :page-sizes="[10, 15, 20, 30]"
        :current-page="params.page"
        :page-size="params.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        v-if="total > 10"
        @size-change="changeSize"
        @current-change="changeCurrent"
      ></el-pagination>
    </div>
    <!--封面图、视频弹窗组件-->
    <preview-video ref="previewVideo"></preview-video>
    <el-dialog
      title="媒体使用"
      align="center"
      :visible.sync="showVidUse"
      width="700px"
      @close="cancelBtn"
    >
      <el-form ref="form" label-width="80px">
        <el-form-item label="种类:" prop="sectionID">
          <el-select v-model="kind" size="small" placeholder="请选择种类">
            <el-option
              v-for="(item, i) in kinds"
              :value="item.value"
              :label="item.label"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型:" size="small" prop="type">
          <el-select
            @change="getTagDimensionsList()"
            clearable
            size="small"
            v-model="type"
            placeholder="请选择类型">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in types"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="纬度:" size="small" prop="dimension">
          <el-select v-model="dimension" placeholder="请选择纬度" clearable>
            <el-option
              v-for="k in dimensions"
              :key="k.id"
              :label="k.name"
              :value="k.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专区:">
          <el-select placeholder="请选择专区" clearable size="small" v-model="mId" @change="changeKind">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in overheadZones"
              :key="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专题:" prop="sectionID">
          <el-select @change="getTagList" laceholder="请选择专区下专题" size="small" v-model="sectionID">
            <el-option
              :label="item.sectionName"
              :value="item.id"
              v-for="item in latitudes"
              :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签:" prop="tagObjs">
          <tag-selector
            v-model="tagObjs"
            :tagList="tagList"
            v-if="isTagSelector"
          ></tag-selector>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelBtn" size="small">取 消</el-button>
        <el-button @click="useAcgMediaRes" type="primary" size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
    <!-- 图集预览窗口 -->
    <preview-picture ref="previewPicture"></preview-picture>
    <!-- 查看子媒体 -->
    <subset-media-list ref="subsetMedia"></subset-media-list>
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import PreviewVideo from "./components/preview-video";
import PreviewPicture from "./components/previewPicture";
import API from "@/api";
import { sortEscape } from "@/utils/global";
import SubsetMediaList from "./components/subsetMediaList.vue";
import TagSelector from "@/components/tagSelector";

export default {
  components: {
    PreviewVideo,
    PreviewPicture,
    SubsetMediaList,
    TagSelector,
  },
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      newImgUrl: baseConfig.newImgUrl,
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      // 列表请求参数
      params: {
        page: 1,
        size: 10,
        is_up: undefined, // 是否是up主 0-不是 1-是 不传则是所有
        media_center_id: undefined, // 媒资中心的中资源唯一id
        media_type: 1, // 1-动画 2-漫画 3-小说
        sync_type: undefined, // 同步类型 1-全量同步 2-增量同步
        tag: undefined, // 标签
        title: undefined, // 标题
        vlogger_id: undefined, // up主id
      },
      is_ups: [
        { label: "否", value: 0 },
        { label: "是", value: 1 },
      ],
      media_types: [
        { label: "动漫", value: 1 },
        { label: "漫画", value: 2 },
        { label: "文字小说", value: 3 },
        { label: "有声小说", value: 4 },
        { label: "短剧", value: 5 },
      ],
      sync_types: [
        { label: "全量", value: 1 },
        { label: "增量", value: 2 },
      ],
      kinds: [
        { label: "哩番", value: 1 },
        { label: "3D", value: 2 },
        { label: "同人动画", value: 3 },
        { label: "单行本", value: 4 },
        { label: "连载漫画", value: 5 },
        { label: "韩漫", value: 6 },
        { label: "有声小说", value: 7 },
        { label: "文字小说", value: 8 },
        { label: "剧场动漫", value: 9 },
        { label: "短剧剧场", value: 10 },
      ],
      types: [
        {
          label: "动漫",
          value: 1,
        },
        {
          label: "漫画",
          value: 2,
        },
        {
          label: "小说",
          value: 3,
        },
        {
          label: "剧场",
          value: 4,
        },
        {
          label: "短剧",
          value: 5,
        },
      ],
      dimensions: [],
      isSelection: false,
      isDisabled: false,
      multipleSelection: [],
      ids: [],
      kind: "", // 使用的种类
      sectionID: "",
      mId: "",
      latitudes: [],
      overheadZones: [],
      tagObjs: [],
      tagList: [], //标签列表：包含标签名称和标签id
      isTagSelector: true,
      type: "", // 类型
      dimension: "", // 纬度
      showVidUse: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 预览
    openSubMedia(row) {
      this.$refs.subsetMedia.open(row, this.media_types);
    },
    getMediaTypeName(mediaType) {
      var mediaTypeName = "";
      for (const m of this.media_types) {
        if (m.value === mediaType) {
          mediaTypeName = m.label;
          break;
        }
      }
      return mediaTypeName;
    },
    // 请求列表
    getList(type) {
      this.loading = true;
      if (type === "status") {
        this.params.page = 1;
      }
      API.queryAcgMediaResConfig(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.tableData.forEach((i) => {
              if (i.tags_text) {
                i.tags_text = i.tags_text.split(",").slice(0, 3);
              }
            });
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //获取种类下媒体话题
    changeKind() {
      if (this.mId === undefined) {
        this.$message.error("请选择专区");
        return;
      }
      this.moduleCartoonAll.filter((item) => {
        if (item.id == this.mId) {
          this.latitudes = item.allSection;
        }
      });
    },
    getModuleCartoonAll() {
      API.queryModuleCartoonAll()
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.moduleCartoonAll = res.data || [];
            this.overheadZones = this.moduleCartoonAll.map((item) => {
              return {
                label: item.moduleName,
                value: item.id,
              };
            });
          } else {
            this.moduleCartoonAll = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.moduleCartoonAll = [];
          this.loading = false;
        });
    },
    getTagList() {
      this.tagList = [];
      if (this.type === undefined) {
        this.$message.error("请选择类型");
        return;
      }
      if (this.dimension === undefined || this.dimension === "") {
        this.$message.error("请选择纬度");
        return;
      }
      const param = {
        type: this.type,
        kind: this.kind,
        dimension: this.dimension,
      };
      API.getMediaTagByKindDimension(param).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data || [];
        }
      });
    },
    giveUp() {
      this.multipleSelection = [];
      this.ids = [];
      this.isDisabled = false;
      this.isSelection = false;
      this.$refs.multipleTable.clearSelection();
    },
    useVideo() {
      if (this.multipleSelection.length <= 0) {
        this.$message.error("请选择使用媒体资源");
        return;
      }
      this.getModuleCartoonAll();
      this.showVidUse = true;
      this.isTagSelector = true;
    },
    // 图集预览
    previewPicture(pictureArr) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr);
    },
    async useAcgMediaRes() {
      let arr = [];
      this.multipleSelection.forEach((i) => {
        arr.push(i.id);
      });
      var tags = [];
      if (this.tagObjs.length > 0); for (const t of this.tagObjs) {
        tags.push(t.id);
      }
      let res = await API.useAcgMediaRes({
        ids: arr,
        section_id: this.sectionID,
        kind: this.kind,
        type: this.type,
        dimension: this.dimension,
        tid: tags,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "使用成功!",
        });
        this.multipleSelection = [];
        this.isSelection = false;
        this.isDisabled = false;
        this.showVidUse = false;
        this.closeShiYong();
        this.getList();
        return;
      }
      this.$message.error(res.msg || res.tip || "操作失败");
    },
    synchronizeMedia() {
      this.$confirm("确认同步资源？")
        .then(async () => {
          let res = await API.acgMediaSync();
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          } else {
            this.$message.error(res.msg || res.tip || "操作失败");
          }
        })
        .catch(() => {});
    },
    async ignoreMedia() {
      let arr = [];
      this.multipleSelection.forEach((i) => {
        arr.push(i.id);
      });
      let res = await API.ignoreAcgMediaRes({
        ids: arr,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.multipleSelection = [];
        this.isSelection = false;
        this.isDisabled = false;
        this.getList();
        return;
      }
      this.$message.error(res.msg || res.tip || "操作失败");
    },
    neglectVideo() {
      if (this.multipleSelection.length <= 0) {
        this.$message.error("请选择使用媒体资源");
        return;
      }
      this.$confirm("确认忽略选中媒体资源？")
        .then(() => {
          this.ignoreMedia();
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    openSelection() {
      this.isSelection = true;
      this.isDisabled = true;
    },
    // 数据排序
    handleSortChange(column) {
      this.params.value = sortEscape(column.order);
      this.params.key = column.prop;
      this.getList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.size = size;
      this.params.page = 1;
      this.getList();
    },
    // 当前页发生变化触发
    changeCurrent(page) {
      this.params.page = page;
      this.getList();
    },
    // 视频查看
    checkMedia(url, type, data) {
      // console.log(url, type, data)
      this.$refs.previewVideo.open(url, type, data);
    },
    // 取消
    cancelBtn() {
      this.showVidUse = false;
      this.closeShiYong();
    },
    closeShiYong() {
      this.sectionID = "";
      this.mId = "";
      this.kind = "";
      this.type = "";
      this.dimension = "";
      this.latitudes = [];
      this.overheadZones = [];
      this.tagObjs = [];
      this.isTagSelector = false;
    },
    checkUrl(domain) {
      if (!domain) {
        return "";
      }
      var patt = /^http(s)?:\/\/.+/;
      if (!patt.test(domain)) {
        if (domain[0] == "/") {
          return this.newImgUrl;
        } else {
          return this.imgUrl;
        }
      } else {
        return "";
      }
    },
    // 请求种类下的纬度列表数据
    getTagDimensionsList() {
      API.getAnimeAllLatitude({
        type: this.type,
      })
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.dimensions = res.data.list || [];
          } else {
            this.dimensions = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.dimensions = [];
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.vid-res-box {
  .tagItem {
    margin: 0 5px 5px;
  }
  /deep/ .el-form-item__content {
    display: flex;
  }
  .param-input {
    width: 220px;
  }
}

.bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn {
  margin-top: 20px;
}
.picturePreview {
  max-width: 300px;
  display: flex;
}
.views {
  color: red;
  font-size: 20px;
  cursor: pointer;
}
</style>
